export class ObjektModel {
    public ObjektID: number = 0;
    public StandortID: number = 0;
    public Bezeichnung: string = "";    
    public Strasse: string = "";
    public PLZ: string = "";
    public Ort: string = "";
    public LandID : number | null=null;
}

export interface ObjektModelView {
     ObjektID?: number
     StandortID?: number
     DebitorID?: number
     DebitorNummer?:string
     DebitorName?:string
     StandortBezeichnung?:string
     Bezeichnung?: string   
     Strasse?: string 
     PLZ?: string 
     Ort?: string 
     LandID?:number
     LandName?:string
     RoofAreaCount?:number
     SafetyPointCount?:number
     DeletedOn?: Date 
} 